module.exports = __webpack_public_path__ + "static/media/american-express.73f0e647.svg";